export default __webpack_public_path__ + "static/cabin4-1cac3e57be9aba72c32a4e78283431da.jpg";